<template>
  <div class="reportLoading">
    <div class="listComSelect">
      <div class="time" @click="showCalendar = true">
        <div
          v-if="timeRange.length === 0"
          style="display: flex;align-items: inherit;"
        >
          <van-icon name="clock-o" />选择指定日期
        </div>
        <div v-else>{{ timeRange.join("至") }}</div>
      </div>
      <van-dropdown-menu>
        <van-dropdown-item v-model="com_id" :options="listCom" />
      </van-dropdown-menu>
    </div>
    <van-divider />
    <p class="title">
      <span>{{ titleTime }}装车效率分析</span>
    </p>
    <div class="pieDiv">
      <div class="pieCanvas" ref="pieCanvas"></div>
      <div v-if="showEmpty" class="emptyDiv">
        <Empty></Empty>
      </div>
    </div>
    <div class="listDiv">
      <div class="greedDiv"></div>
      <div>
        <p class="Accout">总计：{{ allText }}车次</p>
      </div>
      <van-divider />
    </div>
    <template v-for="(item, index) in pieData">
      <section :key="index">
        <div class="itemDiv">
          <div class="circularIcom">
            <span :style="'background-color:' + item.color"></span>
          </div>
          <div class="itemDivR">
            <div class="progressDiv">
              <div class="pb10">{{ item.name }}</div>
              <van-progress
                :percentage="percentText(item.value)"
                :show-pivot="false"
                :color="item.color"
              />
            </div>
            <div class="numDiv">
              <span :style="'color:' + item.color">{{ item.value }}车次</span>
              <span :style="'color:' + item.color"
                >({{ percentText(item.value) }}%)</span
              >
            </div>
          </div>
        </div>
        <van-divider />
      </section>
    </template>
    <van-calendar
      id="vehicleModify"
      v-model="showCalendar"
      color="#009967"
      type="range"
      @confirm="onConfirm"
      :show-confirm="false"
      :show-title="false"
      row-height="58"
      max-range="365"
      :round="false"
      position="right"
      :allow-same-day="true"
      :formatter="formatter"
      :min-date="minDate"
      :max-date="maxDate"
    >
      <template slot="footer">
        <div class="calendar-cont">
          <div style="flex: 1;" @click="setTime(0)">最近一周</div>
          <div style="flex: 1;" @click="setTime(1)">最近一个月</div>
          <div style="flex: 1;" @click="setTime(2)">最近半年</div>
        </div>
      </template>
    </van-calendar>
  </div>
</template>

<script>
import Empty from "@/components/tips/Empty.vue";
import moment from "moment";
export default {
  data() {
    return {
      beginDate: "",
      listCom: [],
      com_id: "",
      pieData: [],
      colorList: [
        "#FF9F7F",
        "#37A2DA",
        "#8378EA",
        "#FFDB5C",
        "#67E0E3",
        "#E690D1",
        "#E062AE",
        "#9FE6B8",
        "#96BFFF",
        "#FB7293",
        "#9D96F5",
        "#E7BCF3",
        "#32C5E9",
        "#F5AD95",
        "#F8AABD",
        "#FDE079",
        "#F5CFD8",
        "#F996AE",
        "#82E4E6",
        "#F6C1CE",
        "#F4E2E6"
      ],
      showEmpty: false,
      showCalendar: false,
      minDate: new Date(moment().year() - 10, 0, 1),
      maxDate: new Date(),
      timeRange: []
    };
  },
  computed: {
    percentText() {
      return pr => {
        if (Number(pr) == 0) {
          return 0;
        }
        let all = 0;
        this.pieData.forEach(item => {
          all += Number(item.value);
        });
        return Number((pr / all).toFixed(4) * 100).toFixed(2);
      };
    },
    allText() {
      let all = 0;
      this.pieData.forEach(item => {
        all += Number(item.value);
      });
      return all;
    },
    titleTime() {
      let text = "";
      if (this.beginDate.slice(0, 4) != this.endDate.slice(0, 4)) {
        let s = moment(this.beginDate).format("YYYY年MM月DD日");
        let e = moment(this.endDate).format("YYYY年MM月DD日");
        text = s + "-" + e;
      } else {
        let s = moment(this.beginDate).format("MM月DD日");
        let e = moment(this.endDate).format("MM月DD日");
        text = s + "-" + e;
      }
      return text;
    }
  },
  async mounted() {
    this.creatPie();
  },
  watch: {
    async com_id() {
      this.creatPie();
    }
  },
  created() {
    this.beginDate = this.$route.query.begin_date;
    if (this.beginDate.length == 0) {
      // 非消息列表进入
      this.beginDate = moment().format("YYYY-MM-DD");
      this.endDate = moment().format("YYYY-MM-DD");
    } else {
      this.endDate = moment(this.beginDate)
        .add(6, "days")
        .format("YYYY-MM-DD");
    }
    this.timeRange.push(moment(this.beginDate).format("YYYY/MM/DD"));
    this.timeRange.push(moment(this.endDate).format("YYYY/MM/DD"));
    this.getListCome();
  },

  components: {
    Empty
  },
  methods: {
    // 快捷选择日期
    setTime(tag) {
      this.timeRange = [];
      let end = new Date();
      let start = new Date();
      if (tag === 0) {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
      } else if (tag === 1) {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      } else if (tag === 2) {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 183);
      }
      this.timeRange.push(moment(start).format("YYYY/MM/DD"));
      this.timeRange.push(moment(end).format("YYYY/MM/DD"));
      this.showCalendar = false;
      this.beginDate = moment(start).format("YYYY-MM-DD");
      this.endDate = moment(end).format("YYYY-MM-DD");
      this.creatPie();
    },
    onConfirm(val) {
      console.log(val);
      this.timeRange = [];
      this.timeRange.push(moment(val[0]).format("YYYY/MM/DD"));
      this.timeRange.push(moment(val[1]).format("YYYY/MM/DD"));
      this.beginDate = moment(val[0])
        .startOf("day")
        .format("YYYY-MM-DD");
      this.endDate = moment(val[1])
        .startOf("day")
        .format("YYYY-MM-DD");
      this.showCalendar = false;
      this.creatPie();
    },
    // 格式化日历显示
    formatter(day) {
      if (day.type === "start") {
        day.bottomInfo = "";
      } else if (day.type === "end") {
        day.bottomInfo = "";
      } else {
        day.bottomInfo = "";
      }
      return day;
    },
    async creatPie() {
      const resData = await this.getData();
      let option = this.getPeiOption(resData);
      let pieEl = null;
      if (!pieEl) {
        pieEl = this.$echarts.init(this.$refs.pieCanvas);
      }
      pieEl.setOption(option, true);
    },
    getListCome() {
      this.$common
        .http({
          url: "/api/queue/summary/list_com"
        })
        .then(res => {
          this.listCom = [{ text: "所有厂区", value: "" }];
          res.data.data.forEach(element => {
            this.listCom.push({ text: element.name, value: element.id });
          });
        });
    },
    getData() {
      return this.$common.http({
        url: "/api/queue/summary/count_wloading_time",
        data: {
          com_id: this.com_id,
          begin_date: this.beginDate,
          end_date: this.endDate
        }
      });
    },
    getPeiOption(resData) {
      let legendData = [];
      let pieData = [];
      this.showEmpty = true;
      Object.keys(resData.data.data).forEach(key => {
        let name = "";
        if (Number(resData.data.data[key]) > 0) {
          this.showEmpty = false;
        }
        if (key == "<1800") {
          name = "小于0.5小时";
        }
        if (key == "1800~3600") {
          name = "0.5~1小时";
        }
        if (key == "3600~7200") {
          name = "1~2小时";
        }
        if (key == "7200~10800") {
          name = "2~3小时";
        }
        if (key == ">=10800") {
          name = "大于3小时";
        }
        legendData.push(name);
        pieData.push({ value: resData.data.data[key], name });
        // 设置颜色
        for (let i = 0; i < pieData.length; i++) {
          if (i < this.colorList.length) {
            pieData[i].color = this.colorList[i];
          } else {
            let ci = i % this.colorList.length;
            pieData[i].color = this.colorList[ci];
          }
        }
        this.pieData = pieData;
      });
      let tempPieData = [];
      this.pieData.forEach(item => {
        if (Number(item.value) > 0) {
          tempPieData.push(item);
        }
      });
      return {
        //  title: {
        //   text: "每周装车效率分析",
        //   left: "center",
        //   top: 0
        // },
        legend: {
          orient: "horizontal",
          data: legendData,
          top: 5
        },
        series: [
          {
            type: "pie",
            radius: "65%",
            center: tempPieData.length > 3 ? ["50%", "60%"] : ["50%", "50%"],
            hoverOffset: 0,
            selectedOffset: 0,
            bottom: 0,
            data: tempPieData,
            label: {
              formatter: "{d}%\n{c}车次"
            },
            itemStyle: {
              normal: {
                color: params => {
                  return params.data.color;
                }
              }
            }
          }
        ]
      };
    }
  }
};
</script>
<style scoped lang="less">
.reportLoading {
  .title {
    text-align: center;
    margin: 10px 0 0 0;
  }
  .pieDiv {
    margin-top: 10px;
    width: 100vw;
    height: 100vw;
    box-sizing: border-box;
    position: relative;
    .pieCanvas {
      width: 100%;
      height: 100%;
    }
  }
  .greedDiv {
    background-color: #e4e4e4;
    height: 10px;
  }
  .listComSelect {
    display: flex;
    align-items: center;
    padding-left: 16px;
    padding-right: 16px;
    justify-content: space-between;
  }
  .Accout {
    padding: 16px;
    margin: 0;
  }
  .itemDiv {
    display: flex;
    padding: 16px;
    justify-content: space-between;
  }
  .itemDivR {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .progressDiv {
    width: calc(100% - 70px);
    padding-right: 10px;
  }
  .numDiv {
    width: 65px;
    display: flex;
    flex-direction: column;
    text-align: right;
  }
  .circularIcom {
    padding-right: 10px;
    padding-top: 8px;
    > span {
      display: inline-block;
      width: 12px;
      height: 12px;
      border-radius: 10px;
    }
  }
  .pb10 {
    padding-bottom: 10px;
  }
  .emptyDiv {
    height: 100vw;
    width: 100vw;
    position: absolute;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 5;
    top: 0;
  }
  .calendar-cont {
    height: 36px;
    font-size: 14px;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    color: #009967;
    background: #f7f7f7;
    box-shadow: 0px 2px 20px rgba(125, 126, 128, 0.16);
  }
  .time {
    flex: 1.7;
    font-size: 12px;
    line-height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #9b9b9b;
    height: 25px;
    background: #f4f5f6;
    margin: 0px 10px 0px 0;
  }
}
</style>
<style lang="less">
.reportLoading {
  .van-dropdown-menu__bar {
    box-shadow: none !important;
  }
  .van-divider {
    margin: 0;
  }
  #vehicleModify .van-calendar__popup.van-popup--left,
  .van-calendar__popup.van-popup--right {
    height: 52vh;
    margin: 0px 30px;
  }
  #vehicleModify .van-calendar__footer {
    padding: 0px;
  }
}
</style>
